// Actions
import { AuthActions, AuthActionTypes } from '../_actions/auth.actions';
// Models
import { User } from '../_models/user.model';

export interface AuthState {
  loggedIn: boolean;
  authToken: string;
  qvToken: string;
  qvSharedToken: string;
  user: any;
  isUserLoaded: boolean;
  twixorToken: string;
  originalRoles: any;
  originalId: number;
  originalUserName: string;
  impersonationRoles: any;
  impersonationId: number;
  impersonationUserName: string;
  impersonationMode: boolean;
}

export const initialAuthState: AuthState = {
  loggedIn: false,
  authToken: undefined,
  qvToken: undefined,
  qvSharedToken: undefined,
  user: {},
  isUserLoaded: false,
  twixorToken: undefined,
  originalRoles: null,
  originalId: null,
  originalUserName: '',
  impersonationRoles: null,
  impersonationId: null,
  impersonationUserName: '',
  impersonationMode: false,
};

export function authReducer(state = initialAuthState, action: AuthActions): AuthState {
  switch (action.type) {
    case AuthActionTypes.Login: {
      const token: string = action.payload.authToken;
      return {
        ...state,
        loggedIn: true,
        authToken: token,
        isUserLoaded: false,
      };
    }
    case AuthActionTypes.Reload: {
      const token: string = action.payload.authToken;
      const user: User = action.payload.userInfo;
      return {
        ...state,
        loggedIn: true,
        authToken: token,
        user: user,
        isUserLoaded: true,
      };
    }

    case AuthActionTypes.Logout:
      return initialAuthState;

    case AuthActionTypes.UserLoaded: {
      const user: User = action.payload.user;
      return {
        ...state,
        user,
        isUserLoaded: true,
      };
    }

    case AuthActionTypes.SetQvTokens: {
      const qvToken = action.payload.qv_token;
      return {
        ...state,
        qvToken,
      };
    }

    case AuthActionTypes.SetTwixorToken: {
      const twixorToken = action.payload.twixor_token;
      return {
        ...state,
        twixorToken,
      };
    }

    // Do nothing
    case AuthActionTypes.RefreshAccessToken: {
      const accessToken: string = action.payload.accessToken;
      return {
        ...state,
        authToken: accessToken,
      };
    }

    case AuthActionTypes.ImpersonationRoles: {
      const impersonationRoles = action.payload.impersonationUser.roles;
      const impersonationId = action.payload.impersonationUser.id;
      const impersonationUserName = action.payload.impersonationUser.userName;
      const originalRoles = state.user.roles;
      const originalId = state.user.id;
      return {
        ...state,
        user: {
          ...state.user,
          id: impersonationId,
          roles: impersonationRoles,
          userName: impersonationUserName,
        },
        originalRoles,
        originalId,
        impersonationRoles,
        impersonationId,
        impersonationUserName,
        impersonationMode: true,
      };
    }
    case AuthActionTypes.OriginalUserRoles: {
      const originalUserRoles = state.originalRoles;
      const originalUserId = state.originalId;
      const originalUserName = state.originalUserName;
      return {
        ...state,
        user: {
          ...state.user,
          id: originalUserId,
          roles: originalUserRoles,
          userName: originalUserName,
        },
        impersonationRoles: null,
        impersonationId: null,
        impersonationMode: false,
        impersonationUserName: '',
        originalRoles: null,
        originalId: null,
        originalUserName: '',
      };
    }
    default:
      return state;
  }
}
